import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { Router, RouterModule, Routes } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatInput } from '@angular/material/input';
import { AccidentService } from '../../../../services/accident/accident.service';

@Component({
    selector: 'app-download-pdf-accident',
    imports: [
        CommonModule,
        MatButtonModule,
        MatCheckboxModule,
        MatInputModule,
        MatRadioModule,
        MatFormFieldModule,
        MatCardModule,
        FormsModule,
        ReactiveFormsModule,
        MatDatepickerModule,
        MatTableModule,
        RouterModule,
        MatProgressSpinnerModule,
        MatIconModule,
        MatMenuModule,
    ],
    templateUrl: './download-pdf-accident.component.html',
    styleUrl: './download-pdf-accident.component.css'
})
export class DownloadPdfAccidentComponent implements OnInit {
  @ViewChild('filterInput') filterInput: MatInput;
  dataSource = new MatTableDataSource<any>();
  displayedColumns: string[] = ['dateOfAccident', 'repEmploy', 'fileUrl', 'attachedFiles']; 
  loading: boolean = true; 
  error: string | null = null; 

  constructor(private accidentService: AccidentService, private router: Router) {}

  ngOnInit(): void {
    this.getAllPdfs();
    this.dataSource.filterPredicate = this.customFilterPredicate();
  }

  getAllPdfs(): void {
    this.accidentService.getAccidentPdfs().subscribe(
      (res) => {
        this.dataSource.data = res;
        this.sortData('desc');
        this.loading = false;
      },
      (error) => {
        this.error = 'Failed to load data';
        this.loading = false;
      }
    );
  }

  sortData(direction: 'asc' | 'desc'): void {
    const sortedData = [...this.dataSource.data].sort((a, b) => {
      const valueA = new Date(a.dateOfAccident).getTime();
      const valueB = new Date(b.dateOfAccident).getTime();
  
      return direction === 'asc'
        ? valueA - valueB
        : valueB - valueA;
    });
  
    this.dataSource.data = sortedData;
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  customFilterPredicate(): (data: any, filter: string) => boolean {
    return (data, filter) => {
      const dateObj = new Date(data.dateOfAccident);
      const formattedDate = dateObj.toLocaleDateString('en-US');
      const formattedDateShort = formattedDate.slice(0, 5);
      const year = dateObj.getFullYear().toString();  
      const normalizedFilter = filter.replace(/^0+/, '').toLowerCase();
      const normalizedFormattedDate = formattedDate.replace(/\/0(\d)\//g, '/$1/');
      const normalizedFormattedShort = formattedDateShort.replace(/\/0(\d)/g, '/$1');
  
      return (
        data.repEmploy?.toLowerCase().includes(normalizedFilter) ||
        formattedDate.includes(filter) ||
        normalizedFormattedDate.includes(normalizedFilter) ||
        formattedDateShort.includes(filter) ||
        normalizedFormattedShort.includes(normalizedFilter) ||
        year.includes(filter)
      );
    };
  }

  clearSort(): void {
    this.getAllPdfs(); 
  }

}
